import styled from 'styled-components'
import { ROOT_PATH } from '../../common/config'

export const Brand = styled.div<{ size?: 'normal' | 'mini' }>`
  height: 120px;
  width: 120px;

  ${({ size }) => {
    if (size === 'mini') {
      return `
      height: 48px;
      width: 65px;  
    `
    }
  }}

  background-position: center;
  background-image: url(${ROOT_PATH}/shenma.png);
  background-repeat: no-repeat;
  background-size: 90px;
  

  @media screen and (max-width: 1000px) {
    height: 60px;
    width: 60px;
    background-size: 45px;
  }
`
